export function index()
{
    return axios.get(route('api.manage.companies.interim-matrix-type-values'))
        .then(response => response.data);
}

export function destroy(valueId)
{
    return axios.delete(route('api.manage.interim-matrix-type-values.destroy', { interimMatrixTypeValueId: valueId }));
}
